import {
  forwardRef,
} from 'react';
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';

import { MediaContentFragment } from '@axis/graphql';
import classNames from '@axis/utils/classnames';
import { Image } from '@axis/components/Image';

function GalleryItem(item: ReactImageGalleryItem) {
  const {
    original: src,
    originalAlt: alt,
    originalHeight,
    originalWidth,
    sizes,
  } = item;

  const isFullscreen = typeof window !== 'undefined' && !window.screenTop && !window.screenY;

  return (
    <div
      className={classNames(
        'image-gallery-image w-full h-full relative flex justify-center',
        isFullscreen
          ? 'max-h-screen'
          : '',
      )}
    >
      <Image
        className={classNames(
          'relative',
          !isFullscreen
            ? 'max-w-xs w-80 h-80 max-h-80'
            : 'w-full h-80 md:h-screen',
        )}
        src={src}
        alt={alt as string}
        sizes={sizes}
        objectFit="contain"
        width={`${originalWidth}`}
        height={`${originalHeight}`}
        layout="fill"
      />
    </div>
  );
}
export interface ProductGalleryProps {
  main: MediaContentFragment;
  images?: MediaContentFragment[];
  className?: string;
}

export const ProductGallery = forwardRef<ImageGallery, ProductGalleryProps>((props, ref) => {
  const {
    main,
    images = [],
    className = '',
  } = props;
  const gallery: ReactImageGalleryItem[] = images.map((image) => ({
    original: image.sourceUrl as string,
    thumbnail: image.thumbnailUrl as string,
    originalWidth: image.mediaDetails?.width as number,
    originalHeight: image.mediaDetails?.height as number,
    originalAlt: image.altText as string,
    thumbnailAlt: image.altText as string,
    srcSet: image.srcSet as string,
    sizes: image.sizes as string,
  }));

  const startIndex = gallery.findIndex(({ original }) => original === main.sourceUrl);

  return (
    <div id="product-gallery" className={className}>
      <ImageGallery
        renderItem={GalleryItem}
        ref={ref}
        items={gallery}
        startIndex={startIndex}
        showBullets
        showNav={false}
        showPlayButton={false}
      />
    </div>
  );
});
